import * as z from "zod";

export const firestoreDocTagSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  order_position: z.number(),
  created_timestamp_secs: z.number(),
});

export type FirestoreDocTag = z.infer<typeof firestoreDocTagSchema>;
